import { render, staticRenderFns } from "./ClientModal.vue?vue&type=template&id=3b7c987e&scoped=true&"
import script from "./ClientModal.vue?vue&type=script&lang=js&"
export * from "./ClientModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientModal.vue?vue&type=style&index=0&id=3b7c987e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7c987e",
  null
  
)

export default component.exports